<template lang="pug">
	.list-control
		input.form-control.form-control-sm(v-for="(value, index) in list" :type="setting.type" :value="value" :placeholder="setting.ControlOptions.placeholder" v-on:change="Settings.setListSettingValue(setting, $event.target.value, index)")
		input.form-control.form-control-sm(:type="setting.type" v-model="newValue" :placeholder="list.length > 0 ? 'put additional url here...' : setting.ControlOptions.placeholder" v-on:change="addNewValue")
</template>

<script>

	import Screen 				from './../../../mixins/screen';

	import { Project } 			from './../../../services/Project';
	import { Settings } 		from './../../../services/Settings';

	export default {
		name: "ListControl",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Project Changed", "Setting Changed"]
		},
		props: ['setting'],
		data() {

			this.Project = Project;
			this.Settings = Settings;

			this.list = [];

			return {
				showed: true,
				newValue: ''
			}

		},
		methods: {
			collectData() {

				let setting = Settings.getSettingValue(this.setting);
				this.list = setting ? setting.split(';') : [];

			},
			addNewValue() {

				Settings.setListSettingValue(this.setting, this.newValue);

				this.newValue = '';

			}
		}
	}
</script>

<style lang="sass">

	.list-control
		display: flex
		justify-content: space-between
		user-select: none
		position: relative
		flex-direction: column


</style>
